const scrollingImageRows = document.querySelectorAll(
  '.digital-scrolling-text-wrapper'
);
scrollingImageRows.forEach((el, i) => {
  window.addEventListener('scroll', () => {
    const scrollTop =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    let windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    const windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (windowWidth < 1000) windowHeight = windowHeight + 200;
    const trackOuter = el.querySelector('.digital-scrolling-text');
    const track = el.querySelector('.digital-scrolling-text');
    // const track = el.querySelector('.scrolling-images');
    const trackWidth = track.offsetWidth;
    // const trackHeight = track.offsetHeight;
    const startX = trackWidth;
    const endX = trackWidth * -1;

    const elTop = el.offsetTop;
    const elHeight = el.offsetHeight;
    const screenBottom = scrollTop + windowHeight;
    const elBottom = elTop + elHeight;
    let scrollPercentage;
    if (screenBottom <= elTop) {
      scrollPercentage = 0;
    } else {
      scrollPercentage = ((screenBottom - elTop) / windowHeight) * 100;
    }

    const rangeX = trackWidth * 0.75;
    const posX = (rangeX / 100) * scrollPercentage * -1 + trackWidth / 2;
    const roundedPostX = Math.ceil(posX / 50) * 50;

    if (scrollTop >= elTop && screenBottom < elBottom)
      trackOuter.classList.add('is-scrolling');
    else trackOuter.classList.remove('is-scrolling');

    if (screenBottom >= elBottom) trackOuter.classList.add('is-scrolled');
    else trackOuter.classList.remove('is-scrolled');

    // if (windowWidth >= 1000)
    track.style.transform = `translateX(${roundedPostX}px)`;
    // else track.style.transform = `translateX(0)`;
  });
});
